import i18n from '@/plugins/i18n'

export const objectTranslator = (object, prefix) => {
    let lang_suffix = '';
    if (i18n.global.locale === 'en') lang_suffix = '_EN';
    else if (i18n.global.locale === 'th') lang_suffix = '_TH';
    else return 'Language service not available';
    return object[prefix + lang_suffix];
}

export const objectTranslatorLowerCase = (object, prefix) => {
    let lang_suffix = '';
    if (i18n.global.locale === 'en') lang_suffix = '_en';
    else if (i18n.global.locale === 'th') lang_suffix = '_th';
    else return 'Language service not available';
    return object[prefix + lang_suffix];
}

export const inlineTranslator = (dict) => {
    if (i18n.global.locale === 'en') return dict.en;
    else if (i18n.global.locale === 'th') return dict.th;
    else return 'Language service not available';
}
export const getLevelName = (level) => {
    if (i18n.global.locale === 'en') {
        if (parseInt(level) === 1) return 'Bachelor';
        else if (parseInt(level) === 2) return 'Master';
        else if (parseInt(level) === 3) return 'Doctor';
    }
    else if (i18n.global.locale === 'th') {
        if (parseInt(level) === 1) return 'ปริญญาตรี';
        else if (parseInt(level) === 2) return 'ปริญญาโท';
        else if (parseInt(level) === 3) return 'ปริญญาเอก';
    }
    return 'no "LEVEL" data available';
}

export const formatNumber = (num) => {
    if (i18n.global.locale === 'en') {
        if (num) return Number(num).toLocaleString() + " Baht";
        else return '-';
    } else {
        if (num) return Number(num).toLocaleString() + " บาท";
        else return '-';
    }
}

export function dateFromDBTranslator(date) {
    if (!date || date == '0000-00-00') {
        return '-';
    } else {
        if (i18n.global.locale === 'en') return this.$dayjs(date, "YYYY-MM-DD").locale('en').format('D MMM YYYY');
        else if (i18n.global.locale === 'th') return this.$dayjs(date, "YYYY-MM-DD").locale('th').format('D MMM BBBB');
        else return 'Language service not available';
    }
}

export function dateFromDBTranslatorFull(date) {
    if (!date || date == '0000-00-00') {
        return '-';
    } else {
        if (i18n.global.locale === 'en') return this.$dayjs(date, "YYYY-MM-DD").locale('en').format('D MMMM YYYY');
        else if (i18n.global.locale === 'th') return this.$dayjs(date, "YYYY-MM-DD").locale('th').format('D MMMM BBBB');
        else return 'Language service not available';
    }
}

export function dateFromDBTranslatorTH(date) {
    if (!date || date == '0000-00-00') {
        return '-';
    } else {
        return this.$dayjs(date, "YYYY-MM-DD").locale('th').format('D MMMM BBBB');
    }
}

export function dateFromDBTranslatorEN(date) {
    if (!date || date == '0000-00-00') {
        return '-';
    } else {
        return this.$dayjs(date, "YYYY-MM-DD").locale('en').format('D MMMM YYYY');
    }
}

export function dateTimeFromDBTranslatorFull(date, color = false) {
    if (!date || date == '0000-00-00 00:00:00') {
        return '-';
    } else {
        let string, date_string, time_string;
        if (i18n.global.locale === 'en') {
            date_string = this.$dayjs(date, "YYYY-MM-DD HH:mm:ss").locale('en').format('D MMMM YYYY');
            time_string = this.$dayjs(date, "YYYY-MM-DD HH:mm:ss").locale('en').format('HH:mm:ss');
        }
        else if (i18n.global.locale === 'th') {
            date_string = this.$dayjs(date, "YYYY-MM-DD HH:mm:ss").locale('th').format('D MMMM BBBB');
            time_string = this.$dayjs(date, "YYYY-MM-DD HH:mm:ss").locale('th').format('HH:mm:ss');
        }
        else return 'Language service not available';

        if (color) {
            const color_list = ['red', '#fdd835', '#F48FB1', '#39D308', '#f57c00', '#2196F3', '#9C27B0',];
            const day = this.$dayjs(date, "YYYY-MM-DD HH:mm:ss").get('day');
            string = `<span style="color: ${color_list[day]};">${date_string}</span> <span style="color: gray;">${time_string}</span>`;
        } else
            string = `${date_string} ${time_string}`;

        return string;
    }
}
